import React, { useState } from "react";
import Navbar from "./component/Navbar";
import Home from "./component/Home";
import Skills from "./component/Skills/Skills";
import Experience from "./component/Experience/Experience";
import Education from "./component/Education/Education";
import Contact from "./component/contact/contact";
import Projects from "./component/Projects";
import ProjectDetails from "./component/ProjectDetails";



function App() {
  const [openModal, setOpenModal] = useState({ state: false, project: null });
  console.log(openModal)

  return (
    <div>
    <Navbar/>
    <Home />
    <Skills />
    <Experience/>
    <Projects openModal={openModal} setOpenModal={setOpenModal} />
    <Education />
    <Contact />
    {openModal.state &&
            <ProjectDetails openModal={openModal} setOpenModal={setOpenModal} />
    }
  </div>
  );
}

export default App;
